import Typesense from 'typesense';
import type { SearchResponse } from 'instantsearch.js';
import TypesenseInstantSearchAdapter, {
  BaseSearchParameters
} from 'typesense-instantsearch-adapter';

import { SearchResponseAdapter } from 'typesense-instantsearch-adapter/lib/SearchResponseAdapter';

export type TypesenseSearchConfig = {
  indexName?: string;
  apiKey: string;
  host: string;
  port: number;
  protocol?: string;
};

export type SearchResponseData = SearchResponse<{
  suggestions: string[];
}>;

export const getTypesenseSearchClient = (
  additionalSearchParameters: BaseSearchParameters,
  config: TypesenseSearchConfig
) => {
  const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
    server: {
      apiKey: config.apiKey,
      nodes: [
        {
          host: config.host,
          port: config.port,
          protocol: config.protocol || 'http'
        }
      ],
      cacheSearchResultsForSeconds: 2 * 60
    },

    additionalSearchParameters
  });

  return typesenseInstantsearchAdapter.searchClient;
};

export const getAutocompleteSearchClient = (config: TypesenseSearchConfig) => {
  const typesenseAutocompleteSearchAdapter = new Typesense.Client({
    apiKey: config.apiKey,
    nodes: [
      {
        host: config.host,
        port: config.port,
        protocol: config.protocol || 'http'
      }
    ],
    connectionTimeoutSeconds: 2
  });

  return typesenseAutocompleteSearchAdapter;
};

export const getSearchResponseAdapter = (result: SearchResponseData) =>
  new SearchResponseAdapter(
    result,
    { params: {} },
    { geoLocationField: '_geoloc' }
  );
